import router from '../../routs/router';

export default {
  state: () => ({
    data: {
      productListCardType: window.innerWidth < 768 ? 2 : 3,
      isOpenFilter: false,
    },
  }),
  mutations: {
    'catalog/setState'(state, payload) {
      state.data = { ...state.data, ...payload };
    },
    'catalog/changeProductListCardType'(state, payload) {
      state.data = { ...state.data, productListCardType: payload };
    },
    'catalog/setOpenFilter'(state, payload) {
      state.data = { ...state.data, isOpenFilter: payload };
    },
    // /**
    //  *
    //  * @param state
    //  * @param {object} payload - елементр фильтра в котором нужно убрать статус выбранного
    //  */
    // ['catalog/deleteSelectedItem'](state, payload) {
    //     try {
    //         let newState = JSON.parse(JSON.stringify(state.data));
    //         let { ITEMS } = newState.catalogSmartFilter;
    //
    //         ITEMS = ITEMS.map(el => {
    //             if (el.CODE === payload.CODE) {
    //                 if (el.DISPLAY_TYPE !== 'A') {
    //                     /** изменяем состояние обычного checkbox **/
    //                     for (let key in el.VALUES) {
    //                         const item = el.VALUES[ key ];
    //                         if (item.CONTROL_ID === payload.CONTROL_ID) {
    //                             item.CHECKED = false;
    //                         }
    //                     }
    //
    //                 } else {
    //
    //                     /** изменяем состояние range price **/
    //                     delete el.VALUES.MIN.HTML_VALUE;
    //                     delete el.VALUES.MAX.HTML_VALUE;
    //                 }
    //             }
    //
    //             return el;
    //         });
    //
    //         state.data = { ...state.data, ...newState };
    //     } catch (err) {
    //         console.error(err);
    //     }
    // },
  },
  actions: {
    /**
     * change catalog catalog filter
     * * */
    async 'catalog/changeFilter'({ state: { data }, commit, dispatch }) {
      try {
        if (data) {
          commit('global/loaderStart');
          const formData = $('.filter').serialize();
          if (!formData) throw 'form is undefined';

          /** бек формирует url на основании отправленной формы * */
          const response = await axios.get(`${location.pathname}?${formData}`);
          const { SEF_SET_FILTER_URL, FILTER_URL } = response.data;
          const url = SEF_SET_FILTER_URL || FILTER_URL;

          /** делаем запрос по сформированном url и и обновляем стору * */
          if (url) {
            dispatch('catalog/changePageData', url);
            // commit('catalog/openFilter', false);
          } else {
            throw `${response}url не сформирован`;
          }
        }
      } catch (err) {
        console.error(err);
      }
    },
    /**
     *
     * @param {function} commit - methods for mutations
     * @param {function} dispatch - methods for actions
     * @param url - url page for ajax request
     * @returns {Q.Promise<void>}
     */
    async 'catalog/changePageData'({ rootState, commit, dispatch, getters }, payload) {
      let url = payload?.url || payload;

      /** using crutches, be careful */
      if (url) {
        url = getters['catalog/clearUrlParam']({ url, param: 'api' });
      }

      try {
        if (!rootState.global.loader) {
          commit('global/loaderStart');
        }
        const response = await axios.get(url, { params: { api: 'y' } });
        if (response.status == 200) {
          commit('catalog/setState', response.data);
          commit('global/loaderStop');
          router.push(url);
        }
      } catch (err) {
        console.error(err);
      }
    },
    async 'catalog/updatePageData'({ rootState, commit }) {
      try {
        if (!rootState.global.loader) {
          commit('global/loaderStart');
        }
        const response = await axios.get(location.href, { params: { api: 'y' } });
        if (response.status == 200) {
          commit('catalog/setState', response.data);
          commit('global/loaderStop');
        }
      } catch (err) {
        console.error(err);
      }
    },
    /**
     * add more items
     * * */
    async 'catalog/getMoreItems'({ state: { data }, commit }) {
      try {
        const { pagingKey, pageNumber } = data?.catalogSectionList?.pagination;
        const config = {
          params: {
            api: 'y',
            [pagingKey]: +pageNumber + 1,
          },
        };
        commit('global/loaderStart');
        const { status, data: response } = await axios.get(window.location.href, config);

        if (status === 200) {
          const newData = { ...data, ...response };
          newData.catalogSectionList.items = [
            ...data.catalogSectionList?.items,
            ...response?.catalogSectionList?.items,
          ];

          commit('catalog/setState', newData);
        }
        commit('global/loaderStop');
      } catch (err) {
        console.error(err);
      }
    },
    //     /**
    //      * delete selected filter element
    //      */
    //     ['catalog/deleteSelectedFilter']({ commit, dispatch }, payload) {
    //         try {
    //             commit('catalog/deleteSelectedItem', payload);
    //             setTimeout(() => dispatch('catalog/changeFilter'), 4);
    //         } catch (err) {
    //             console.error(err);
    //         }
    //     },
  },
  getters: {
    'catalog/clearUrlParam': (state) => (payload) => {
      const url = payload.url.split('?');
      if (url?.[1]) {
        return url
          .map((el, ind) => {
            switch (ind) {
              case 1:
                const searchParams = new URLSearchParams(`?${el}`);
                searchParams.delete(payload.param);
                return searchParams.toString();
              default:
                return el;
            }
          })
          .join('?');
      }
      return payload.url;
    },
    //     ['catalog/getSelectedFilters'](state) {
    //         const items = state.data?.catalogSmartFilter?.ITEMS;
    //         let arr = [];
    //
    //         if (items) {
    //             for (let key in items) {
    //                 const subObj = items[key].VALUES;
    //
    //                 if (items[key].DISPLAY_TYPE === 'A') {
    //                     /** get string for price range**/
    //                     const range = {};
    //                     let newObj = {
    //                         ...items[key],
    //                         CODE: items[key].CODE
    //                     }
    //                     for (let i in subObj) {
    //                         if (subObj[i].HTML_VALUE) {
    //                             range[i] = subObj[i].HTML_VALUE;
    //                         }
    //                     }
    //
    //                     if (range && range.MIN && range.MAX) {
    //                         newObj.printRange = `от ${range.MIN} до ${range.MAX}`;
    //                     } else if (range.MIN) {
    //                         newObj.printRange = `от ${range.MIN}`;
    //                     } else if (range.MAX) {
    //                         newObj.printRange = `до ${range.MAX}`;
    //                     }
    //                     if (newObj.printRange) {
    //                         arr.push(newObj);
    //                     }
    //
    //                 } else if (items[key].VALUES) {
    //                     /** get all checkbox **/
    //                     for (let i in subObj) {
    //                         if (subObj[i].CHECKED) {
    //                             arr.push({
    //                                 ...subObj[i],
    //                                 CODE: items[key].CODE,
    //                             });
    //                         }
    //                     }
    //                 }
    //             }
    //         }
    //
    //         return arr;
    //     },
    //     ['catalog/isAzerCell'](state) {
    //         return state.data?.catalogSectionList?.settings?.template === 'azercell-nomreler';
    //     }
  },
};
